export function ProgressIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="10" cy="16.5" rx="8" ry="2.5" fill="#657EAB" />
      <path
        d="M8.90532 2.37873C8.96096 2.15615 9.16095 2 9.39039 2H17.7929C18.2383 2 18.4614 2.53857 18.1464 2.85355L15.2548 5.74517C15.1026 5.89735 15.0649 6.12984 15.1612 6.32233L16.6382 9.27639C16.8044 9.60884 16.5627 10 16.191 10H7.64039C7.3151 10 7.07642 9.69431 7.15532 9.37873L8.90532 2.37873Z"
        fill="#F56666"
      />
      <path
        d="M9 2L5.5 16"
        stroke="#A9D1DD"
        stroke-width="1.6"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function RightArrow() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.29169 15.4167L12.7084 9.99999L7.29169 4.58332"
        stroke="#AFB6BA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ThoughtRecordIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2538_5606)">
        <path
          d="M5.80644 1.62188C6.35973 1.1147 7.08304 0.833344 7.83362 0.833344H16.3333C17.4379 0.833344 18.3333 1.72877 18.3333 2.83334V17.1667C18.3333 18.2712 17.4379 19.1667 16.3333 19.1667H3.66666C2.56209 19.1667 1.66666 18.2712 1.66666 17.1667V6.73638C1.66666 5.89546 2.0196 5.09315 2.63949 4.52492L5.80644 1.62188Z"
          fill="#FFE7A5"
        />
        <path
          d="M3.33334 6.66667H7.5V2.5"
          stroke="#FCD771"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <mask
          id="mask0_2538_5606"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="2"
          width="17"
          height="17"
        >
          <path
            d="M16.3466 2.37379C16.7372 1.98327 17.3703 1.98327 17.7608 2.37379L19.2929 3.90586C19.6834 4.29638 19.6834 4.92955 19.2929 5.32007L7.64478 16.9682C7.2472 17.3658 6.74589 17.6436 6.19803 17.7701L4.14164 18.2446C3.7096 18.3443 3.32239 17.9571 3.42209 17.5251L3.89664 15.4687C4.02307 14.9208 4.30092 14.4195 4.6985 14.0219L16.3466 2.37379Z"
            fill="#FFAF00"
          />
        </mask>
        <g mask="url(#mask0_2538_5606)">
          <path
            d="M16.3466 2.37379C16.7372 1.98327 17.3703 1.98327 17.7608 2.37379L19.2929 3.90586C19.6834 4.29638 19.6834 4.92955 19.2929 5.32007L7.64478 16.9682C7.2472 17.3658 6.74589 17.6436 6.19803 17.7701L4.14164 18.2446C3.7096 18.3443 3.32239 17.9571 3.42209 17.5251L3.89664 15.4687C4.02307 14.9208 4.30092 14.4195 4.6985 14.0219L16.3466 2.37379Z"
            fill="#FFAF00"
          />
          <rect
            x="17.0537"
            y="1.66669"
            width="4.16667"
            height="4.16667"
            transform="rotate(45 17.0537 1.66669)"
            fill="#F582B2"
          />
          <path
            d="M4.67936 14.041L7.62564 16.9873L4.67936 19.9336L1.73308 16.9873L4.67936 14.041Z"
            fill="#FFF7E1"
          />
          <rect
            x="3.50085"
            y="15.2196"
            width="4.16667"
            height="2.5"
            transform="rotate(45 3.50085 15.2196)"
            fill="#433C29"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2538_5606">
          <rect width="20" height="20" rx="3.6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AddIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 20 20`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 4.16667L10.5 15.8333"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.3333 10H4.66659"
        stroke={"currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function MeditationIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2538_5616)">
        <path
          d="M4.32688 6.24196C7.01982 3.54902 11.1713 2.93972 13.9816 2.87149C15.7693 2.82808 17.1688 4.22763 17.1254 6.01533C17.0572 8.82559 16.4479 12.9771 13.755 15.67C10.8084 18.6167 6.11545 19.0686 3.34415 19.0467C2.00302 19.0361 0.960835 17.9939 0.950239 16.6528C0.928344 13.8815 1.38027 9.18856 4.32688 6.24196Z"
          fill="#76B958"
        />
        <path
          d="M4.16666 15.8333C9.69909 10.3009 12.8009 7.19908 18.3333 1.66666"
          stroke="#4F9031"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M8.02002 7.19971L13.001 6.76393"
          stroke="#4F9031"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M4.84167 11.0149L8.99248 10.6518"
          stroke="#4F9031"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M12.8004 11.98L13.2361 6.99901"
          stroke="#4F9031"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M8.98508 15.1583L9.34823 11.0075"
          stroke="#4F9031"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2538_5616">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LearningActivityIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.333 0.833008C17.4375 0.833008 18.3328 1.72859 18.333 2.83301V13C18.333 14.1046 17.4376 15 16.333 15H5.83301C5.37303 15.0002 5.00018 15.373 5 15.833C5 16.2931 5.37292 16.6668 5.83301 16.667H17.334C17.8857 16.667 18.333 17.1143 18.333 17.666C18.333 18.4944 17.6614 19.166 16.833 19.166H5.66699C3.45785 19.166 1.66699 17.3752 1.66699 15.166V4.83301C1.66717 2.62402 3.45796 0.833008 5.66699 0.833008H16.333Z"
        fill="#7697D3"
      />
      <rect
        x="5"
        y="4.16669"
        width="10"
        height="1.66667"
        rx="0.833333"
        fill="#3760A9"
      />
      <rect
        x="5"
        y="7.08331"
        width="6.66667"
        height="1.66667"
        rx="0.833333"
        fill="#3760A9"
      />
    </svg>
  );
}
